import { ListPage } from '@components/molecules';
import { TextFieldElement } from 'react-hook-form-mui';
import { Grid } from '@mui/material';
import API from '@apps/accounts/services/groups';
import { ModelProps } from '@/types';
import { useTranslation } from 'react-i18next';
import { JSX } from 'react';
import { GroupsSchema } from '@apps/accounts/schemas/groups';
import { SearchSchema } from '@/defaultschemas/search';

export default function GroupListPage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      hide: true,
    },
    {
      field: 'name',
      headerName: t('Name'),
      flex: 1,
    },
  ];

  return (
    <ListPage
      schema={GroupsSchema}
      schemaSearch={SearchSchema}
      title={t('Groups')}
      api={API}
      columns={columns}
      modelProps={modelProps}
      customPath={'account/group'}
    >
      <Grid size={{ xs: 12, md: 3 }}>
        <TextFieldElement name="search" label={t('Search')} fullWidth />
      </Grid>
    </ListPage>
  );
}
